import React, { ReactElement } from 'react';

import joinUsClientSvg from 'assets/images/join-us/join-us-client.inline.svg';
import joinUsCompanySvg from 'assets/images/join-us/join-us-company.inline.svg';
import Button from 'atomic/button/button';
import Link from 'atomic/link/link';

import './join-us-options.scss';

interface JoinUsOptionsProps {
    onChooseNextStep: () => void;
    onClose: () => void;
}

const JoinUsOptions: React.FC<JoinUsOptionsProps> = ({ onChooseNextStep, onClose }): ReactElement => (
    <div className="join-us-options">
        <div className="join-us-options__body">
            <div className="join-us-options__block join-us-options__block--client">
                <p className="join-us-options__header">
                    <strong className="join-us-options__header-strong">
                        Jestem użytkownikiem
                    </strong>
                    <br/>
                    {' '}
                    i chcę zaproponować sklep lub firmę
                </p>
                <img className="join-us-options__img" src={joinUsClientSvg} alt="Jestem użytkownikiem" title="Jestem użytkownikiem"/>
                {' '}
                <Button className="join-us-options__button" uppercase={true} onClick={(): void => onChooseNextStep()}>
                    Zaproponuj sklep lub firmę
                </Button>
            </div>
            <div className="join-us-options__block join-us-options__block--company">
                <p className="join-us-options__header">
                    <strong className="join-us-options__header-strong">
                        Reprezentuję sklep lub firmę
                    </strong>
                    <br/>
                    {' '}
                    i chcę przystąpić do Opineo
                </p>
                <img className="join-us-options__img" src={joinUsCompanySvg} alt="Reprezentuję sklep lub firmę" title="Reprezentuję sklep lub firmę"/>
                <Link type="button" className="company button-link" href="https://dolacz.opineo.pl/#dolacz-do-opineo" uppercase={true}>
                    Przystąp do Opineo
                </Link>
            </div>
        </div>
        <div className="join-us__footer">
            <Button className="join-us__footer-button" wrapper={true} onClick={onClose}>
                Wróć do strony
            </Button>
        </div>
    </div>
);

export default JoinUsOptions;
